export enum ManagerRoles {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MODERATOR = 'MODERATOR'
}

export type ManagerRolesTypes = `${ManagerRoles}`;
